import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import loadPaystackScript from "../../../../utilities/loadPaystackScript";
import "./Payment.css";
import { selectUser } from "../../../../redux/features/userSlice";

import logo from "../../../../assets/img/vibelogo.png";
import { Link } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

export default function Payment({ calendlyLink }) {
  const user = useSelector(selectUser);
  const [amount, setAmount] = useState(process.env.REACT_APP_BASE_AMOUNT);
  const [sessions, setSessions] = useState(1);
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [paystackLoaded, setPaystackLoaded] = useState(false);
  const [coupon, setCoupon] = useState("");

  useEffect(() => {
    loadPaystackScript("https://js.paystack.co/v1/inline.js")
      .then(() => setPaystackLoaded(true))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    setAmount(process.env.REACT_APP_BASE_AMOUNT * sessions);
  }, [sessions]);

  const payWithPaystack = (e) => {
    e.preventDefault();

    if (!paystackLoaded) {
      alert("Paystack script not loaded yet");
      return;
    }

    let handler = window.PaystackPop.setup({
      key: "pk_live_a42246663ec4db45ad68bbaf82698ce4c1759b0f", // Replace with your public key
      email: email,
      amount: `${amount}` * 100,
      currency: "KES",
      channels: ["mobile_money", "card"],
      ref: "" + Math.floor(Math.random() * 1000000000 + 1), // Generates a pseudo-unique reference.
      callback: function (response) {
        let message = "Payment complete! Reference: " + response.reference;
        alert(message);
        console.log(response);
        // Open Calendly link in a new tab after successful payment
        window.open(calendlyLink, "_blank");

        // Redirect to Calendly link in the same tab after successful payment
        // window.location.href = calendlyLink;
      },
      onClose: function () {
        alert("Transaction was not completed, window closed.");
      },
    });

    handler.openIframe(); // Use iframe instead of popup
  };
  return (
    <div className="payment">
      <div className="payment-container">
        <div className="payment-header">
          <img src={logo} alt="logo" />
          <Link to={`/therapists`} className="back-button">
            <KeyboardBackspaceIcon className="back-button-icon" />
          </Link>
        </div>
        <form
          id="paymentForm"
          onSubmit={payWithPaystack}
          className="paymentForm"
        >
          <input
            type="text"
            placeholder="Full Name*"
            required
            id="full-name"
            className={"full-name"}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          <input
            type="email"
            id="email-address"
            className="email"
            placeholder="Enter email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="form-group">
            <input
              type="number"
              id="sessions"
              className="sessions"
              placeholder="Number of sessions"
              value={sessions}
              onChange={(e) => setSessions(e.target.value)}
              required
              min={1}
            />
            <input
              type={"text"}
              id="coupon"
              className="coupon"
              placeholder="Coupon Code"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
            />
          </div>
          <button type="submit" className="submit-btn">
            Pay
          </button>
        </form>
      </div>
    </div>
  );
}
